import styled from 'styled-components';
import { MarkerIcon } from '@rsos/assets/icons';
import { Button, Box } from '@rsos/base-components';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { getTokens } from '@rsos/sinatra';
import { useCurrentOrgName } from '@rsos/sinatra/src/selectors';
import { postLocationShareRequestUrl } from '@rsos/utils/fetchPublicServices';

const RequestButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
})`
  height: auto;
  padding: 4px 2px;
`;

interface RequestLocationProps {
  onSuccess: (url: string) => void;
}

const RequestLocation = ({ onSuccess }: RequestLocationProps) => {
  const tokens = getTokens();
  const orgName = useCurrentOrgName();
  const callerID = useSelectedCallerID() || '';

  const fetchUrl = async () => {
    const result = await postLocationShareRequestUrl(
      callerID,
      orgName,
      tokens?.token,
    );
    onSuccess(result);
  };
  return (
    <Box padding="8px 16px 16px">
      <RequestButton onClick={fetchUrl}>
        <MarkerIcon height={12} width={12} />
        Request Location
      </RequestButton>
    </Box>
  );
};

export default RequestLocation;
